import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=0835eb63&scoped=true"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"
import style0 from "./WelcomeMessage.vue?vue&type=style&index=0&id=0835eb63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835eb63",
  null
  
)

export default component.exports